/**
 * Material-UI Theme Configuration
 * Uses simplified color system - change themeColors in colors.js to retheme
 */

import { createTheme } from '@mui/material/styles';
import { colors, grey } from './colors';
import { typography } from './typography';
import { components } from './components';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: colors.primary,
    secondary: colors.secondary,
    success: colors.success,
    warning: colors.warning,
    error: colors.error,
    info: colors.info,
    background: colors.background,
    text: colors.text,
    divider: colors.divider,
    grey,
  },
  typography,
  components,
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
  // Soft, low-cap elevation ramp (cool-neutral shadow color, max ~0.14 alpha)
  shadows: [
    'none',
    '0 1px 2px rgba(16,24,32,0.04)',
    '0 1px 3px rgba(16,24,32,0.06)',
    '0 2px 6px rgba(16,24,32,0.07)',
    '0 4px 10px rgba(16,24,32,0.08)',
    '0 6px 14px rgba(16,24,32,0.09)',
    '0 8px 18px rgba(16,24,32,0.10)',
    '0 10px 22px rgba(16,24,32,0.11)',
    '0 12px 26px rgba(16,24,32,0.12)',
    '0 14px 30px rgba(16,24,32,0.12)',
    '0 16px 34px rgba(16,24,32,0.13)',
    '0 18px 38px rgba(16,24,32,0.13)',
    '0 20px 42px rgba(16,24,32,0.13)',
    '0 22px 46px rgba(16,24,32,0.13)',
    '0 24px 50px rgba(16,24,32,0.14)',
    '0 26px 54px rgba(16,24,32,0.14)',
    '0 28px 58px rgba(16,24,32,0.14)',
    '0 30px 62px rgba(16,24,32,0.14)',
    '0 32px 66px rgba(16,24,32,0.14)',
    '0 34px 70px rgba(16,24,32,0.14)',
    '0 36px 74px rgba(16,24,32,0.14)',
    '0 38px 78px rgba(16,24,32,0.14)',
    '0 40px 82px rgba(16,24,32,0.14)',
    '0 42px 86px rgba(16,24,32,0.14)',
    '0 44px 90px rgba(16,24,32,0.14)',
  ],
});

export default theme;
